import { render, staticRenderFns } from "./VolanCard.vue?vue&type=template&id=447e8450&scoped=true"
import script from "./VolanCard.vue?vue&type=script&lang=js"
export * from "./VolanCard.vue?vue&type=script&lang=js"
import style0 from "./VolanCard.vue?vue&type=style&index=0&id=447e8450&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_css-loader@6.11.0_webpack_53a2985e0d5a2f62f061ee97dc298f7f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447e8450",
  null
  
)

export default component.exports